export default {
  name: "Billing",
  meta: {
    icon: "account_balance_wallet",
    expanded: true,
    auth: true,
  },

  departmentName: "Accounts",
  finalPagePermision: "",

  children: [
    {
      name: "Billing Assignment Details",
      path: "/viewBillingDetails/viewBillingDetails",
      permissionName: "Billing",
      keywords: [
        "Billing",
        "Sales Execution Billing",
        "Expense List",
        "Invoices",
        "Proforma",
        "Billing Reports",
        "Billing Invoice Dashboard",
      ],
      meta: {
        icon: "account_balance_wallet",
        auth: true,
      },
      component: require("../component/allModuleForm/viewBillingDetails.vue"),
      finalPagePermision: "",
    },
    {
      name: "TAT Dashboard",
      path: "/freight/tat-dashboard",
      permissionName: "ULIP",
      keywords: ["TAT Dashboard", "Turn Around Time", "Job TAT", "ULIP TAT"],
      meta: {
        icon: "dashboard",
        auth: true,
      },
      component: require("../component/ulip/TATDashboard.vue"),
      finalPagePermision: "",
    },
    {
      name: "Failed Billing",
      path: "/viewBillingDetails/viewFailedBillingDetails",
      permissionName: "Billing",
      keywords: [
        "Billing",
        "Sales Execution Billing",
        "Expense List",
        "Invoices",
        "Proforma",
        "Billing Reports",
        "Billing Invoice Dashboard",
      ],
      meta: {
        icon: "account_balance_wallet",
        auth: true,
      },
      component: require("../component/tally/viewBillingDetails.vue"),
      finalPagePermision: "",
    },
    {
      name: "CLOSED.AGENT EXPENSE PENDING D/B",
      path: "/viewBillingDetails/viewClosedAgentExpensePending",
      permissionName: "Billing",
      keywords: [
        "Billing",
        "Sales Execution Billing",
        "Expense List",
        "Invoices",
        "Proforma",
        "Billing Reports",
        "Billing Invoice Dashboard",
      ],
      meta: {
        icon: "account_balance_wallet",
        auth: true,
      },
      component: require("../component/allModuleForm/viewBillingDetails.vue"),
      finalPagePermision: "",
    },
    {
      name: "Port Expense",
      path: "/port-expense",
      permissionName: "Billing",
      keywords: ["Port Expense"],
      meta: {
        icon: "directions_boat",
        auth: true,
      },
      component: require("../component/portExpenseModule/Tab.vue"),
      // component: require("../component/portExpenseModule/portExpenseUpload.vue"),
      finalPagePermision: "",
    },
    {
      name: "Billing Container Dash",
      path: "/not-billed-container",
      permissionName: "Billing",
      keywords: ["Billing Container Dash"],
      meta: {
        icon: "directions_boat",
        auth: true,
      },
      component: require("../component/containerDash/NotBilledContainerDash.vue"),
      finalPagePermision: "",
    },
    {
      name: "Reports List",
      path: "/newBillingReports/newBillingReports",
      permissionName: "Billing",
      keywords: [
        "Billing",
        "Billing Reports",
        "Expense List",
        "Invoices",
        "Sales Execution Billing",
        "Proforma",
        "Billing Invoice Dashboard",
      ],
      meta: {
        icon: "account_balance_wallet",
        auth: true,
      },
      component: require("../component/reports/newBillingReports.vue"),
      finalPagePermision: "",
    },
    {
      name: "Invoice List",
      path: "/viewInvoiceDetails",
      permissionName: "Billing",
      keywords: [
        "Billing",
        "Invoices",
        "Expense List",
        "Sales Execution Billing",
        "Proforma",
        "Billing Reports",
        "Billing Invoice Dashboard",
      ],
      meta: {
        icon: "account_balance_wallet",
        auth: true,
      },
      component: require("../component/allModuleForm/viewInvoiceDetails.vue"),
      finalPagePermision: "",
    },
    {
      name: "All Purchases",
      path: "/allPurchases",
      permissionName: "Purchases",
      keywords: [
        "Billing",
        "Invoices",
        "Expense List",
        "Sales Execution Billing",
        "Proforma",
        "Billing Reports",
        "Billing Invoice Dashboard",
      ],
      meta: {
        icon: "account_balance_wallet",
        auth: true,
      },
      component: require("../component/expense/allPurchases.vue"),
      finalPagePermision: "",
    },
    {
      name: "Expense List",
      path: "/expenselist",
      permissionName: "Expenses",
      keywords: [
        "Billing",
        "Invoices",
        "Expense List",
        "Sales Execution Billing",
        "Proforma",
        "Billing Reports",
        "Billing Invoice Dashboard",
      ],
      meta: {
        icon: "account_balance_wallet",
        auth: true,
      },
      component: require("../component/expense/expenseList.vue"),
      finalPagePermision: "",
    },
    {
      name: "Inv/Exp Item List",
      path: "/itemExpInvList",
      permissionName: "Expenses",
      keywords: [
        "Billing",
        "Invoices",
        "Expense List",
        "Sales Execution Billing",
        "Proforma",
        "Billing Reports",
        "Inv/Exp Item List",
        "Billing Invoice Dashboard",
      ],
      meta: {
        icon: "account_balance_wallet",
        auth: true,
      },
      component: require("../component/expense/itemExpInvList.vue"),
      finalPagePermision: "",
    },
    {
      name: "GRN Details",
      path: "/transport/GRNdetails",
      permissionName: "Sea Export",
      keywords: [
        "Transportation Execution",
        "Execution Details",
        "Assignment  Details",
        "Transportation Reports",
        "Transportation",
        "Wheels Track",
        "Daily TPT Expense",
        "GRN Details",
      ],
      meta: {
        icon: "local_shipping ",
        auth: true,
      },
      component: require("../component/expense/GRNdetails.vue"),
      finalPagePermision: "",
    },
    {
      name: "Lock Panel Dashboard",
      path: "/lock-dash",
      permissionName: "Billing",
      keywords: [
        "Billing",
        "Invoices",
        "Expense List",
        "Proforma",
        "Sales Execution Billing",
        "Billing Reports",
        "Billing Invoice Dashboard",
        "Lock Panel Dashboard",
      ],
      meta: {
        icon: "account_balance_wallet",
        auth: true,
      },
      component: require("../component/dashboard/lockPannelDash.vue"),
      finalPagePermision: "",
    },
    {
      name: "Proforma List",
      path: "/proformaList",
      permissionName: "Billing",
      keywords: [
        "Billing",
        "Invoices",
        "Expense List",
        "Proforma",
        "Sales Execution Billing",
        "Billing Reports",
        "Billing Invoice Dashboard",
      ],
      meta: {
        icon: "account_balance_wallet",
        auth: true,
      },
      component: require("../component/proforma/proformaList.vue"),
      finalPagePermision: "",
    },
    {
      name: "Billing Invoice Dashboard",
      path: "/billInvDash",
      permissionName: "Invoice Dashboard",
      keywords: [
        "Billing",
        "Invoices",
        "Expense List",
        "Proforma",
        "Sales Execution Billing",
        "Billing Reports",
        "Billing Invoice Dashboard",
      ],
      meta: {
        icon: "dashboard",
        auth: true,
      },
      component: require("../component/dashboard/billingInvDash.vue"),
      finalPagePermision: "",
    },
    {
      name: "Invoices Document",
      path: "/billInvList",
      permissionName: "Invoice Dashboard",
      keywords: [
        "Billing",
        "Invoices",
        "Expense List",
        "Proforma",
        "Sales Execution Billing",
        "Billing Reports",
        "Billing Invoice Dashboard",
      ],
      meta: {
        icon: "dashboard",
        auth: true,
      },
      component: require("../component/invoice/billingInvList.vue"),
      finalPagePermision: "",
    },
    {
      name: "Assignment P&L List",
      path: "/P&LDashboard",
      permissionName: "PL_List",
      keywords: ["Assignment P&L List"],
      meta: {
        icon: "account_balance_wallet",
        auth: true,
      },
      component: require("../component/dashboard/profitlossDashboard.vue"),
      finalPagePermision: "",
    },
    {
      name: "OF INV/BILLS",
      path: "/bill/ocean-freight",
      permissionName: "Billing",
      keywords: [
        "Billing",
        "Sales Execution Billing",
        "Expense List",
        "Invoices",
        "Proforma",
        "Billing Reports",
        "Billing Invoice Dashboard",
      ],
      meta: {
        icon: "account_balance_wallet",
        auth: true,
      },
      component: require("../component/ulip/Tab.vue"),
      finalPagePermision: "",
    },
    {
      name: "Ledger Outstanding",
      path: "/ledger-outstanding",
      permissionName: "Billing",
      keywords: [
        "Billing",
        "Sales Execution Billing",
        "Expense List",
        "Invoices",
        "Proforma",
        "Billing Reports",
        "Billing Invoice Dashboard",
      ],
      meta: {
        icon: "account_balance_wallet",
        auth: true,
      },
      component: require("../component/ledgerOutstanding/outstanding.vue"),
      finalPagePermision: "",
    },
    {
      name: "Outstanding Dashboard",
      path: "/ledger-outstanding-dash",
      permissionName: "Billing",
      keywords: [
        "Billing",
        "Sales Execution Billing",
        "Expense List",
        "Invoices",
        "Proforma",
        "Billing Reports",
        "Billing Invoice Dashboard",
      ],
      meta: {
        icon: "account_balance_wallet",
        auth: true,
      },
      component: require("../component/ledgerOutstanding/outstandingDash.vue"),
      finalPagePermision: "",
    },
    {
      name: "Payment List",
      path: "/payment/purchase",
      // path: "/payment/:type",
      meta: {
        icon: "directions_boat",
        auth: true,
      },
      component: require("../component/payment/getPaymentList.vue"),
      finalPagePermision: "",
    },
    {
      name: "P&L Approval",
      path: "/profitLoss/approvalList",
      permissionName: "Billing",
      keywords: [
        "Billing",
        "Sales Execution Billing",
        "Expense List",
        "Invoices",
        "Proforma",
        "Billing Reports",
        "Billing Invoice Dashboard",
        "P&L Approval",
      ],
      meta: {
        icon: "account_balance_wallet",
        auth: true,
      },
      component: require("../component/profitLoss/ProfitLossApprovalList.vue"),
      finalPagePermision: "",
    },
    // {
    //     name: "Expense Approval Request",
    //     path: "/payment/approval",
    //     meta: {
    //         icon: "directions_boat",
    //         auth: true,
    //     },
    //     component: require("../component/payment/PaymentApprovalList.vue"),
    //     finalPagePermision: "",
    // },
  ],
};



// WEBPACK FOOTER //
// ./src/sidebar/billingForm.js